<template>
  <form class="form" autocomplete="off" @submit.prevent="submit">
    <h2>{{ $t('newExam.TITLE') }}</h2>
    <BaseInput
      :label="$t('baseExamForm.label.NAME')"
      :placeholder="$t('baseExamForm.NAME_PLACEHOLDER')"
      type="text"
      v-model="exam.name"
    />
    <label>{{ $t('baseExamForm.label.START') }}
      <date-picker v-model="exam.start"/>
    </label>
    <label>{{ $t('baseExamForm.label.END') }}
      <date-picker v-model="exam.end"/>
    </label>
    <BaseInput
      :label="$t('baseExamForm.label.TIMING')"
      :placeholder="$t('baseExamForm.TIMING_PLACEHOLDER')"
      type="number"
      v-model="exam.timing"
      min="0"
      max="2147483647"
    />
    <label>{{ $t('baseExamForm.label.PROCTORING') }}
      <multiselect
        v-model="exam.proctoring"
        :searchable="false"
        :selectLabel="$t('selectExam.label.SELECT')"
        :deselectLabel="$t('selectExam.label.DESELECT')"
        :customLabel="getProctoringLabel"
        :options="proctoringOptions"
        :placeholder="$t('baseExamForm.PROCTORING_PLACEHOLDER')"
      />
    </label>
    <label>{{ $t('baseExamForm.label.COMMISSION') }}
      <select-members
        v-model="exam.commission_members"
        :options="commission"/>
    </label>
    <file-upload-button
      class="file-upload-container"
      v-model="papersFile"
      :buttonText="$t('baseExamForm.UPLOAD_BUTTON')"
      :helpText="$t('baseExamForm.UPLOAD_HELP')"/>
    <div v-if="errors.length" class="errors-container">
      <ul>
        <li class="error" v-for="error in errors" :key="error">{{ error }}</li>
      </ul>
    </div>
    <div class="submit-container">
      <input class="primary-button" type="submit" :value="$t('newExam.SUBMIT_BUTTON')">
    </div>
  </form>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import exam from '@/mixins/exam'

export default {
  name: 'NewExam',
  mixins: [exam],
  data () {
    return {
      exam: this.newExam(),
      papersRequired: true,
      prefix: 'newExam'
    }
  },
  created () {
    this.$loading.start()

    const promises = []

    this.user.companies
      .forEach((companyId) => {
        promises.push(
          this.fetchCompanyUsers(companyId)
            .then(users => this.commission.push(...users))
        )
      })

    Promise.all(promises)
      .catch(() => this.$loading.fail())
      .finally(() => this.$loading.done())
  },
  methods: {
    newExam () {
      return {
        name: '',
        start: '',
        end: '',
        timing: '',
        proctoring: '',
        commission_members: []
      }
    },
    afterProcessed (examData, papers) {
      const newExamPromise = this.createNewExam(examData)

      this.$awn.async(
        newExamPromise,
        exam => this.onExamSuccess(exam, papers),
        this.onExamFailure,
        this.$t('newExam.awn.SEND_FORM')
      )
    },
    onExamSuccess (exam, papers) {
      this.$awn.success(this.$t('newExam.awn.EXAM_SUCCESS'))
      this.sendPapers(exam, papers)
    },
    onExamFailure (error) {
      if (error.response?.status === 400) {
        const serverMsg = error.response?.data[0] || ''
        const errorMsg = `${this.$t('newExam.awn.EXAM_FAILURE')} ${serverMsg}`
        this.$awn.alert(errorMsg)
      } else {
        this.$awn.alert(this.$t('newExam.awn.EXAM_FAILURE'))
      }
    },
    onPapersSuccess () {
      this.$awn.success(this.$t('newExam.awn.PAPERS_SUCCESS'))
      this.$router.push({ name: 'Exams' })
    },
    onPapersFailure () {
      this.$awn.alert(this.$t('newExam.awn.PAPERS_FAILURE'))
      this.$router.push({ name: 'Exams' })
    },
    ...mapActions([
      'fetchCompanyUsers',
      'createNewExam',
      'uploadPapers'
    ])
  },
  computed: mapState(['user'])
}
</script>

<style lang="scss" scoped>
@import "~@/styles/base.scss";

</style>
